/* eslint-disable react/no-multi-comp */
/* eslint-disable max-classes-per-file */

import React from 'react';
import {
  Tabs as ReactTabs,
  TabList as ReactTabList,
  Tab as ReactTab,
  TabPanel as ReactTabPanel,
  TabsProps,
} from 'react-tabs';
import classNames from 'classnames';
import styles from './tabs.module.scss';

class Tabs extends React.Component<{
  onSelect: TabsProps['onSelect'];
}> {
  static tabsRole: string = 'Tabs';

  render() {
    const { children, ...rest } = this.props;
    return (
      <ReactTabs {...rest} className="" selectedTabClassName={styles.active}>
        {children}
      </ReactTabs>
    );
  }
}

class TabList extends React.Component {
  static tabsRole: string = 'TabList';

  render() {
    const { children, ...rest } = this.props;
    return (
      <ReactTabList
        {...rest}
        className={classNames(styles.container, styles.snippet)}
      >
        {children}
      </ReactTabList>
    );
  }
}

class Tab extends React.Component {
  static tabsRole: string = 'Tab';

  render() {
    const { children, ...rest } = this.props;
    return (
      <ReactTab {...rest} className={classNames(styles.tab, styles.tabSmall)}>
        {children}
      </ReactTab>
    );
  }
}

class TabLabel extends React.Component<{
  dataValue?: string;
}> {
  render() {
    const { children, dataValue, ...rest } = this.props;
    return (
      <div
        {...rest}
        data-value={dataValue}
        className={classNames(styles.label, styles.labelSmall)}
      >
        {children}
      </div>
    );
  }
}

class TabPanel extends React.Component {
  static tabsRole: string = 'TabPanel';

  render() {
    const { children, ...rest } = this.props;
    return <ReactTabPanel {...rest}>{children}</ReactTabPanel>;
  }
}

export { Tab, TabList, Tabs, TabPanel, TabLabel };

/* eslint-enable react/no-multi-comp */
/* eslint-enable max-classes-per-file */
